import { render } from "./pharmacie_admin_dashboard.vue?vue&type=template&id=328ff2e2"
import script from "./pharmacie_admin_dashboard.vue?vue&type=script&lang=js"
export * from "./pharmacie_admin_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__